import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/OffSiteRecharge/recharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-OffSiteRecharge-recharge" */ '~/pages/OffSiteRecharge/pages/recharge'
        )
    ),
  },
  {
    path: '/OffSiteRecharge/verify',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-OffSiteRecharge-verify" */ '~/pages/OffSiteRecharge/pages/verify'
        )
    ),
  },
  {
    path: '/OffSiteRecharge/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-OffSiteRecharge-rule" */ '~/pages/OffSiteRecharge/pages/rule'
        )
    ),
  },
] as RouteConfig[]
